import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class H3ToParent extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.h3toparent',
        group: 'Spatial Indexes',
        title: 'H3 To Parent',
        description: `
        Add a new column named h3_parent with the value of the parent h3 at a specific resolution.
        If required resolution is higher than h3 column, a null value will be set.
        `,
        starred: false,
        deprecated: false,
        tags: []
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'h3',
          type: WorkflowComponentParamType.Column,
          title: 'H3 index column',
          parent: 'source',
          dataType: [ColumnDataType.String]
        },
        {
          name: 'resolution',
          type: WorkflowComponentParamType.Number,
          title: 'Resolution',
          min: 0,
          max: 15,
          mode: WorkflowComponentParameterMode.Slider
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    const namespace = `${connection.quoteName(envVars.analyticsToolboxDataset as string)}`
    const sourceT = connection.quoteName(params.source as string)

    switch (connection.type) {
      case Provider.DatabricksRest:
        return `SELECT /*+ REPARTITION(40) */
          H3_TOPARENT(
            ${params.h3},
            CAST(${params.resolution} AS INTEGER)
          ) h3_parent,
          *
        FROM
          ${sourceT}`
      default:
        return `SELECT
              ${namespace}.H3_TOPARENT(
                ${params.h3},
                CAST(${params.resolution} AS INTEGER)
              ) h3_parent,
              *
            FROM
              ${sourceT}`
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    switch (provider) {
      default:
        return '1.0.0'
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    switch (provider) {
      // leaved switch in case have to add more provider specific cases
      default:
        return '1.0.0'
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'h3_parent',
      type: ColumnDataType.String
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake, Provider.Postgres, Provider.DatabricksRest]
  }
}

export { H3ToParent }
